import { Trans, useTranslation } from 'react-i18next';
import { getDurationTranslation, isKorean } from 'src/services/util';

/**
 * SUB_CREATED
 */
export default function AutoPaymentCreatedCard({ obj }: { obj: CheckoutUserProduct }): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="mt-3">
      <div className="border border-ice-blue bg-white rounded px-6 py-6">
        <div className="N_16_R text-black">{isKorean() ? obj.koName : obj.enName}</div>
        <div className="N_12_R text-brown-grey mt-1">
          <Trans i18nKey={getDurationTranslation(obj.durationType)} values={{ period: obj.duration }}></Trans>
        </div>
        <div className="mt-4 flex">
          <div className="N_12_R text-brown-grey">{t('product/auto-payment/payment_status')}</div>
          <div className="N_12_R text-ice-blue w-3 text-center">|</div>
          <div className="N_12_M text-bluey-purple">{t('product/auto-payment/sub_created_message')}</div> {/* TODO +1일? */}
        </div>
      </div>
    </div>
  );
}
